import { ShipmentDto } from ".";
var ApproachingDiscountDto = (function () {
    function ApproachingDiscountDto(conditionThreshold, discount, merchandiseTotal, promotionLink, shipmentId, shippingMethods, type) {
        if (conditionThreshold === void 0) { conditionThreshold = 0; }
        if (discount === void 0) { discount = ""; }
        if (merchandiseTotal === void 0) { merchandiseTotal = 0; }
        if (promotionLink === void 0) { promotionLink = { callout: '', name: '', id: '' }; }
        if (shipmentId === void 0) { shipmentId = ""; }
        if (shippingMethods === void 0) { shippingMethods = []; }
        if (type === void 0) { type = ""; }
        this.conditionThreshold = conditionThreshold;
        this.discount = discount;
        this.merchandiseTotal = merchandiseTotal;
        this.promotionLink = promotionLink;
        this.shipmentId = shipmentId;
        this.shippingMethods = shippingMethods;
        this.type = type;
    }
    ApproachingDiscountDto.fromOcapi = function (ocapiResponse) {
        var _a;
        var shipments = ((_a = ocapiResponse.shipping_methods) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ShipmentDto.fromOcapi(item); })) || [];
        var promotionLink = {
            callout: ocapiResponse.promotion_link.callout_msg,
            name: ocapiResponse.promotion_link.name,
            id: ocapiResponse.promotion_link.promotion_id
        };
        return new ApproachingDiscountDto(ocapiResponse.condition_threshold, ocapiResponse.discount, ocapiResponse.merchandise_total, promotionLink, ocapiResponse.shipment_id, shipments, ocapiResponse.type);
    };
    return ApproachingDiscountDto;
}());
export { ApproachingDiscountDto };
//# sourceMappingURL=ApproachingDiscountDto.js.map